<template>

  <Toast/>
  <div class="card">
    <Steps :model="items" :readonly="true"/>
  </div>

  <Card style="border-radius:12px;">
    <template v-slot:title>
      Nombre
    </template>
    <template v-slot:subtitle>
      Añadir bloque
    </template>
    <template #content>
      <div class="filters">

        <!--          Name            -->
        <div class="field">
          <span class="p-float-label">
            <InputText id="name" type="text" v-model="blockName" class="form-input"/>
            <label for="name">Nombre de bloque</label>
          </span>
        </div>
      </div>


    </template>
    <template #footer>
      <div class="grid grid-nogutter justify-content-end">
        <!--          <Button label="Back" @click="prevPage()" icon="pi pi-angle-left" />-->
        <Button label="Siguiente"
                @click="nextPage()"
                icon="pi pi-angle-right"
                iconPos="right"
                :disabled="this.blockName ? disabled : ''"
        />
      </div>
    </template>
  </Card>

  <router-view v-slot="{Component}"
               @prevPage="prevPage($event)"
               @nextPage="nextPage($event)">
    <keep-alive>
      <component :is="Component"/>
    </keep-alive>
  </router-view>

</template>

<script>


export default {
  name: "Step1",
  created() {
    this.blockName = this.$store.getters.getBlock.blockName;
  },
  data() {
    return {
      items: [
        {
          label: 'Nombre',
          to: '/bloques/agregar-1'
        },
        {
          label: 'Dirección',
          to: '/bloques/agregar-2'
        },
        {
          label: 'Porcentajes',
          to: '/bloques/agregar-3'
        }
      ],
      blockName: null,
      pageIndex: 0,
      roleId: null,
    }
  },

  methods: {
    nextPage() {
      this.$store.commit('setBlock', {
        id_comercializador: this.$store.getters.getBlock.id_comercializador,
        blockName: this.blockName,
        id_estado: this.$store.getters.getBlock.id_estado,
        id_municipio: this.$store.getters.getBlock.id_municipio,
      });
      this.$router.push({name: 'bloques/agregar-2',})
    },

  }
}
</script>

<style scoped lang="scss">
::v-deep(b) {
  display: block;
}

::v-deep(.p-card-body) {
  padding: 2rem;
}

.filters {
  margin-top: 10px;
}

.filterItem {
  margin: 2px 0 5px 0;
}


</style>